import * as React from "react";
import { VeboxModels } from "../../../../../types/veboxModels";
import { DeviceModelListItem } from "../DeviceModelListItem";
import "./styles.scss";
import { createDeviceTypesFilter } from "../../widgets/Filters/TelemetryFilter/utils";
import { ADDITIONAL_FILTERS } from "../../types";
import { FindEquipmentContext } from "../../providers/FindEquipmentProvider";

interface DeviceModelsListProps {
	devicesModels: VeboxModels.DeviceModel[];
}

export const DeviceModelsList: React.FC<DeviceModelsListProps> = ({
	devicesModels,
}) => {
	const {
		handleVeBoxAdditionalFilters,
		additionalVeBoxFilters,
		isRemovingAll,
	} = React.useContext(FindEquipmentContext);

	const [isFirstRender, setIsFirstRender] = React.useState(true);
	const [deviceTypesGuids, setDeviceTypesGuids] = React.useState<string[]>([]);

	const onItemToggle = (guid: string) => {
		setIsFirstRender(false);
		const newGuids = deviceTypesGuids?.includes(guid)
			? deviceTypesGuids?.filter((deviceTypesGuid) => deviceTypesGuid !== guid)
			: [...deviceTypesGuids, guid];
		setDeviceTypesGuids(newGuids);
	};

	React.useEffect(() => {
		if (isFirstRender) {
			return;
		}
		if (deviceTypesGuids.length > 0) {
			handleVeBoxAdditionalFilters(
				"add",
				createDeviceTypesFilter(deviceTypesGuids),
				ADDITIONAL_FILTERS.DEVICE_MODELS,
			);
		} else {
			handleVeBoxAdditionalFilters(
				"remove",
				createDeviceTypesFilter(
					additionalVeBoxFilters?.deviceFiltersCategory?.deviceModelGuids,
				),
				ADDITIONAL_FILTERS.DEVICE_MODELS,
			);
		}
	}, [deviceTypesGuids]);

	React.useEffect(() => {
		if (isRemovingAll) {
			setDeviceTypesGuids([]);
		}
	}, [isRemovingAll]);

	const sortByNames = (
		firstModel: VeboxModels.DeviceModel,
		secondModel: VeboxModels.DeviceModel,
	) => {
		if (firstModel.name !== secondModel.name) {
			return firstModel.name < secondModel.name ? -1 : 1;
		}
		return 0;
	};
	const models = React.useMemo(() => {
		return devicesModels
			?.sort(sortByNames)
			.map((deviceModel: VeboxModels.DeviceModel) => {
				return (
					<DeviceModelListItem
						guid={deviceModel?.guid}
						onItemToggle={onItemToggle}
						logo={deviceModel.logo}
						name={deviceModel?.name}
						selected={deviceTypesGuids.includes(deviceModel?.guid)}
					/>
				);
			});
	}, [devicesModels, deviceTypesGuids]);
	return <div className={`device-models-list`}>{models}</div>;
};
